/**
 * Store Plugin to proxy all mutations to EXO
 */
export default store => {
  store.subscribe((mutation, state) => {
    if (window.__EXORDX__) {
      window.__EXORDX__.dispatch({
        ...mutation,
        type: `@@vue/${mutation.type}`
      });
    }
  });
};
